import { IconNames } from 'atoms/Icon'
import { Background, BorderColors } from 'atoms/RadioButton/RadioButton.h'
import { RadioAccentMain } from 'atoms/RadioButton/Templates'
import {
  TextBoxMaxLine1Footnote4,
  TextBoxMaxLine1Headline3,
  TextBoxMaxLine2Caption5,
} from 'atoms/TextBox/Templates'
import { CardCorners } from 'blocks/Cards'
import { COLOR, FIXED_INDENTS } from 'vars/index'
import {
  PaymentCardBody,
  PaymentCardHeader,
  PaymentCardSC,
  PaymentCardWrapper,
} from './PopupComponents.styled'

export interface IPaymentCard {
  paddings?: FIXED_INDENTS[]
  title: string
  cost: string
  description: string
  backgroundColor?: COLOR
  backgroundColorHovered?: COLOR
  backgroundColorPressed?: COLOR
  backgroundColorSelected?: COLOR
  backgroundColorSelectedHovered?: COLOR
  backgroundColorSelectedPressed?: COLOR
  selected?: boolean
  onClick?: () => void
  icon?: IconNames
  corners?: CardCorners
}

export const PaymentCard = ({
  paddings = [
    FIXED_INDENTS.INDENT_20,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_40,
  ],
  title,
  cost,
  description,
  backgroundColor = COLOR.SURFACE_OPACITY_LIGHT_10,
  backgroundColorHovered = COLOR.SURFACE_OPACITY_LIGHT_15,
  backgroundColorPressed = COLOR.SURFACE_OPACITY_LIGHT_20,
  backgroundColorSelected = COLOR.ACCENT_PRIMARY_GRADIENT,
  backgroundColorSelectedHovered = COLOR.ACCENT_SECONDARY,
  backgroundColorSelectedPressed = COLOR.ACCENT_PRIMARY_PRESSED,
  selected,
  onClick,
  icon = IconNames.check,
  corners = CardCorners.CORNERS_20,
}: IPaymentCard) => {
  return (
    <PaymentCardWrapper
      paddings={paddings}
      onClick={onClick}
      checked={selected!}
      backgroundColor={backgroundColor}
      backgroundColorHovered={backgroundColorHovered}
      backgroundColorPressed={backgroundColorPressed}
      backgroundColorSelected={backgroundColorSelected}
      backgroundColorSelectedHovered={backgroundColorSelectedHovered}
      backgroundColorSelectedPressed={backgroundColorSelectedPressed}
    >
      <RadioAccentMain
        checked={selected!}
        id={title + cost}
        name={'Payment Option'}
        value={title}
        icon={icon}
        background={Background.SURFACE_OPACITY_DARK_40}
        backgroundChecked={Background.SURFACE_OPACITY_DARK_40}
        borderColor={BorderColors.SURFACE_OPACITY_LIGHT_10}
      />
      <PaymentCardSC paddings={paddings} corners={corners}>
        <PaymentCardHeader>
          <TextBoxMaxLine1Footnote4 title={title} />
        </PaymentCardHeader>
        <PaymentCardBody>
          <TextBoxMaxLine1Headline3 title={cost} />
          <TextBoxMaxLine2Caption5 title={description} />
        </PaymentCardBody>
      </PaymentCardSC>
    </PaymentCardWrapper>
  )
}
